'use strict';

var CATEGORY_NOSTO_SLOT_PLACEMENT_ID = 'categorypage-nosto-2';
var DESKTOP_BREAKPOINT = '(min-width: 768px)';

function initNostoSearch() {
    var root = document.querySelector('.search-page');
    var refinementState = {
        key: '',
        html: ''
    };
    var activeRequestId = 0;
    var resizeTimer;

    if (!root) {
        return;
    }

    function getConfig() {
        return {
            accountId: root.getAttribute('data-nosto-account-id') || '',
            tilesUrl: root.getAttribute('data-tiles-url') || '',
            refinementsUrl: root.getAttribute('data-refinements-url') || '',
            categoryPath: root.getAttribute('data-category-path') || '',
            currency: root.getAttribute('data-currency') || '',
            recommendationTileUrl: root.getAttribute('data-recommendation-tile-url') || '',
            recommendationPositionDesktop: getPositiveInteger(root.getAttribute('data-recommendation-position-desktop')),
            recommendationPositionMobile: getPositiveInteger(root.getAttribute('data-recommendation-position-mobile'))
        };
    }

    function getPositiveInteger(value) {
        var parsedValue = parseInt(value, 10);

        return !isNaN(parsedValue) && isFinite(parsedValue) && parsedValue > 0
            ? parsedValue
            : null;
    }

    function getRecommendationPosition(config) {
        var isDesktop = window.matchMedia && window.matchMedia(DESKTOP_BREAKPOINT).matches;

        return isDesktop ? config.recommendationPositionDesktop : config.recommendationPositionMobile;
    }

    function getParam(name) {
        var url = new URL(window.location.href);
        return url.searchParams.get(name) || '';
    }

    function numberParam(name, fallback) {
        var value = parseInt(getParam(name) || '', 10);
        return !isNaN(value) && isFinite(value) ? value : fallback;
    }

    function setPaginationParams(start, size) {
        var url = new URL(window.location.href);
        var safeSize = Math.max(1, parseInt(size, 10) || 24);
        var safeStart = Math.max(0, parseInt(start, 10) || 0);
        var page = Math.floor(safeStart / safeSize) + 1;

        url.searchParams.set('start', String(safeStart));
        url.searchParams.set('sz', String(safeSize));
        url.searchParams.set('page', String(page));
        window.history.replaceState({}, '', url.toString());
    }

    function buildPageUrl(start, size) {
        var url = new URL(window.location.href);
        var safeSize = Math.max(1, parseInt(size, 10) || 24);
        var safeStart = Math.max(0, parseInt(start, 10) || 0);
        var page = Math.floor(safeStart / safeSize) + 1;

        url.searchParams.set('start', String(safeStart));
        url.searchParams.set('sz', String(safeSize));
        url.searchParams.set('page', String(page));
        return url.toString();
    }

    function triggerBackToTop() {
        var backToTopButton = document.querySelector('.back-to-top');

        if (backToTopButton) {
            backToTopButton.click();
            return;
        }

        window.scrollTo(0, 0);
    }

    function normalizeSortRule(value) {
        var normalized = String(value || '').toLowerCase().trim();

        if (!normalized || normalized === 'bestmatches' || normalized.indexOf('best match') > -1) {
            return 'bestmatches';
        }

        return normalized;
    }

    function getSortRuleFromUrl() {
        return normalizeSortRule(getParam('srule'));
    }

    function getSortConfigByRule(sortRule) {
        var select = document.querySelector('[name="sort-order"]');
        var options;
        var index;
        var option;
        var optionRule;

        if (!select) {
            return null;
        }

        options = select.querySelectorAll('option[data-id]');
        for (index = 0; index < options.length; index++) {
            option = options[index];
            optionRule = normalizeSortRule(option.getAttribute('data-id'));

            if (optionRule !== sortRule) {
                continue;
            }

            return {
                id: optionRule,
                type: String(option.getAttribute('data-type') || '').toLowerCase(),
                field: String(option.getAttribute('data-field') || ''),
                order: String(option.getAttribute('data-order') || '').toLowerCase()
            };
        }

        return null;
    }

    function applySortToProductsQuery(productsQuery, sortRule) {
        var sortConfig = getSortConfigByRule(sortRule);

        if (!sortConfig || sortConfig.type === 'relevance') {
            return;
        }

        if (sortConfig.type === 'field' && sortConfig.field && (sortConfig.order === 'asc' || sortConfig.order === 'desc')) {
            productsQuery.sort = [{
                field: sortConfig.field,
                order: sortConfig.order
            }];
        }
    }

    function syncSortSelection(sortRule) {
        var select = document.querySelector('[name="sort-order"]');
        var options;
        var index;
        var optionRule;
        var matched = false;
        var bestMatchOption = null;
        var placeholderOption = null;

        if (!select) {
            return;
        }

        options = select.querySelectorAll('option');

        for (index = 0; index < options.length; index++) {
            optionRule = options[index].getAttribute('data-id');

            if (!optionRule && options[index].classList.contains('sort-text')) {
                placeholderOption = options[index];
            }

            if (normalizeSortRule(optionRule) === 'bestmatches') {
                bestMatchOption = options[index];
            }

            if (optionRule && normalizeSortRule(optionRule) === sortRule) {
                options[index].selected = true;
                matched = true;
            } else {
                options[index].selected = false;
            }
        }

        if (!matched) {
            if (sortRule === 'bestmatches' && bestMatchOption) {
                bestMatchOption.selected = true;
            } else if (placeholderOption) {
                placeholderOption.selected = true;
            } else if (options.length) {
                options[0].selected = true;
            }
        }

        if (sortRule === 'bestmatches') {
            $('.sort-text').removeClass('d-none');
        } else {
            $('.sort-text').addClass('d-none');
        }
    }

    function getAllParams() {
        var params = {};
        var url = new URL(window.location.href);

        url.searchParams.forEach(function (value, key) {
            params[key] = value;
        });

        return params;
    }

    function getSelectedFilterMap() {
        var map = {};
        var params = getAllParams();

        Object.keys(params).forEach(function (key) {
            if (key.indexOf('nf_') !== 0) {
                return;
            }

            var field = key.substring(3);
            var values = String(params[key] || '').split('|').map(function (value) {
                return value ? value.trim() : '';
            }).filter(Boolean);

            if (field && values.length) {
                map[field] = values;
            }
        });

        return map;
    }

    function buildFacetStateKey(query, categoryPath, selectedFilterMap) {
        var parts = [String(query || ''), String(categoryPath || '')];

        Object.keys(selectedFilterMap).sort().forEach(function (field) {
            var values = selectedFilterMap[field].slice(0).sort();
            parts.push(field + ':' + values.join('|'));
        });

        return parts.join('||');
    }

    function buildNostoFilters(selectedFilterMap, categoryPath) {
        var filters = [];
        var normalizedMap = {};
        var rangeTokenPattern = /^range:([-+]?\d*\.?\d+):([-+]?\d*\.?\d*)$/;

        Object.keys(selectedFilterMap).forEach(function (field) {
            normalizedMap[field] = selectedFilterMap[field].slice(0);
        });

        if (categoryPath) {
            var categoryValues = normalizedMap.categories ? normalizedMap.categories.slice(0) : [];
            if (categoryValues.indexOf(categoryPath) === -1) {
                categoryValues.push(categoryPath);
            }
            normalizedMap.categories = categoryValues;
        }

        Object.keys(normalizedMap).forEach(function (field) {
            var rangeFilters = [];
            var termFilters = [];

            if (!normalizedMap[field].length) {
                return;
            }

            normalizedMap[field].forEach(function (token) {
                var match = token ? token.match(rangeTokenPattern) : null;
                var minValue;
                var maxToken;
                var maxValue;
                var rangeFilter;

                if (!match) {
                    termFilters.push(token);
                    return;
                }

                minValue = parseFloat(match[1]);
                maxToken = match[2];
                maxValue = maxToken === '' ? null : parseFloat(maxToken);

                if (isNaN(minValue) || !isFinite(minValue)) {
                    termFilters.push(token);
                    return;
                }

                rangeFilter = {
                    gte: String(minValue)
                };

                if (maxValue !== null && !isNaN(maxValue) && isFinite(maxValue)) {
                    rangeFilter.lt = String(maxValue);
                }

                rangeFilters.push(rangeFilter);
            });

            if (termFilters.length) {
                filters.push({
                    field: field,
                    value: termFilters
                });
            }

            if (rangeFilters.length) {
                filters.push({
                    field: field,
                    range: rangeFilters
                });
            }
        });

        return filters;
    }

    function extractSearchNode(response) {
        if (response && response.products) {
            return response;
        }

        if (response && response.data && response.data.search) {
            return response.data.search;
        }

        return null;
    }

    function formatTotal(total) {
        var parsed = parseInt(total, 10);

        if (isNaN(parsed) || !isFinite(parsed) || parsed < 0) {
            parsed = 0;
        }

        return parsed.toLocaleString() + ' ITEMS';
    }

    function applyHref(href) {
        var nextUrl = new URL(href, window.location.href);
        window.history.replaceState({}, '', nextUrl.toString());
    }

    function searchNosto(requestPayload, options) {
        return new Promise(function (resolve, reject) {
            if (typeof window.nostojs !== 'function') {
                reject(new Error('nostojs client not available'));
                return;
            }

            window.nostojs(function (api) {
                Promise.resolve(api.search(requestPayload, options)).then(resolve).catch(reject);
            });
        });
    }

    function getResultsShimmerMarkup(size) {
        var count = Math.min(Math.max(parseInt(size, 10) || 0, 6), 12);
        var html = '';
        var index;

        for (index = 0; index < count; index++) {
            html += '' +
                '<div class="col-6 col-sm-6 col-md-3 nosto-shimmer-col" aria-hidden="true">' +
                    '<div class="nosto-shimmer-tile"></div>' +
                '</div>';
        }

        return html;
    }

    function getRefinementShimmerMarkup() {
        return '' +
            '<div class="nosto-shimmer-refinements" aria-hidden="true">' +
                '<div class="nosto-shimmer-line"></div>' +
                '<div class="nosto-shimmer-line short"></div>' +
                '<div class="nosto-shimmer-line"></div>' +
                '<div class="nosto-shimmer-line short"></div>' +
                '<div class="nosto-shimmer-line"></div>' +
            '</div>';
    }

    function fetchTilesHtml(tilesUrl, ids) {
        if (!ids || !ids.length || !tilesUrl) {
            return Promise.resolve('');
        }

        var url = new URL(tilesUrl, window.location.origin);
        url.searchParams.set('ids', ids.join(','));

        return fetch(url.toString(), { credentials: 'same-origin' }).then(function (response) {
            if (!response.ok) {
                throw new Error('Tiles endpoint failed: ' + response.status);
            }
            return response.text();
        });
    }

    function getProductTileColumns(resultsEl) {
        return Array.prototype.slice.call(resultsEl.children).filter(function (child) {
            return child.querySelector('[data-product-tile="true"]');
        });
    }

    function removeInlineCategoryRecommendation(resultsEl) {
        var inlineSlot = resultsEl.querySelector('[data-nosto-inline-slot="' + CATEGORY_NOSTO_SLOT_PLACEMENT_ID + '"]');

        if (inlineSlot) {
            inlineSlot.parentNode.removeChild(inlineSlot);
        }
    }

    function appendInlineCategoryRecommendation(slotWrapper, tileUrl) {
        var slotContainer;
        var recommendationNode;
        var tileUrlContainer;

        if (!tileUrl) {
            return;
        }

        slotContainer = document.createElement('div');
        slotContainer.className = 'html-slot-container';

        recommendationNode = document.createElement('div');
        recommendationNode.className = 'js-nosto-reco';
        recommendationNode.setAttribute('data-placement-id', CATEGORY_NOSTO_SLOT_PLACEMENT_ID);
        slotContainer.appendChild(recommendationNode);

        tileUrlContainer = document.createElement('div');
        tileUrlContainer.className = 'js-nosto-tile-url';
        tileUrlContainer.style.display = 'none';
        tileUrlContainer.setAttribute('data-url', tileUrl);

        slotWrapper.appendChild(slotContainer);
        slotWrapper.appendChild(tileUrlContainer);
    }

    function renderInlineCategoryRecommendation(resultsEl, tileUrl, position) {
        var productTiles;
        var slotWrapper;
        var anchorTile;
        var anchorIndex;
        var recommendationPosition;

        if (!resultsEl) {
            return;
        }

        removeInlineCategoryRecommendation(resultsEl);
        recommendationPosition = getPositiveInteger(position);

        if (!recommendationPosition) {
            return;
        }

        productTiles = getProductTileColumns(resultsEl);
        if (!productTiles.length) {
            return;
        }

        slotWrapper = document.createElement('div');
        slotWrapper.className = 'col-12 nosto-search-inline-recommendation';
        slotWrapper.setAttribute('data-nosto-inline-slot', CATEGORY_NOSTO_SLOT_PLACEMENT_ID);
        appendInlineCategoryRecommendation(slotWrapper, tileUrl);

        if (!slotWrapper.querySelector('.js-nosto-reco')) {
            return;
        }

        anchorIndex = Math.min(productTiles.length, recommendationPosition) - 1;
        anchorTile = productTiles[anchorIndex];
        anchorTile.parentNode.insertBefore(slotWrapper, anchorTile.nextSibling);

        if (window.__loadedNostoPlacements) {
            delete window.__loadedNostoPlacements[CATEGORY_NOSTO_SLOT_PLACEMENT_ID];
        }

        if (typeof window.runNostoReco === 'function') {
            window.runNostoReco();
        }
    }

    function fetchRefinementsHtml(refinementsUrl, facets, hasResults, total, currency) {
        if (!refinementsUrl) {
            return Promise.resolve('');
        }

        return fetch(refinementsUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                facets: facets || [],
                queryParams: getAllParams(),
                hasResults: hasResults,
                total: total || 0,
                currency: currency || ''
            })
        }).then(function (response) {
            if (!response.ok) {
                throw new Error('Refinements endpoint failed: ' + response.status);
            }

            return response.text();
        });
    }

    function renderPagination(total, size, from) {
        var resultsEl = document.getElementById('nosto-results');
        var footer;
        var arrows;
        var leftCol;
        var linksCol;
        var rightCol;
        var currentPage;
        var totalPages;
        var pageNumbers = [];
        var page;
        var pageLink;
        var prevStep;
        var firstArrow;
        var nextStep;
        var lastArrow;
        var skip;
        var lastPage;
        var start;

        if (!resultsEl) {
            return;
        }

        footer = resultsEl.querySelector('.nosto-grid-footer');
        if (footer) {
            footer.parentNode.removeChild(footer);
        }

        if (!total || total <= size) {
            return;
        }

        currentPage = Math.floor(from / size) + 1;
        totalPages = Math.ceil(total / size);
        if (totalPages <= 4) {
            for (page = 1; page <= totalPages; page++) {
                pageNumbers.push(page);
            }
        } else if (currentPage <= 3) {
            pageNumbers = [1, 2, 3];
        } else if (currentPage >= totalPages - 2) {
            pageNumbers = [totalPages - 2, totalPages - 1, totalPages];
        } else {
            pageNumbers = [currentPage - 1, currentPage, currentPage + 1];
        }

        footer = document.createElement('div');
        footer.className = 'col-12 grid-footer nosto-grid-footer';
        footer.setAttribute('data-page-size', String(size) + '.0');
        footer.setAttribute('data-page-number', String(currentPage - 1));

        arrows = document.createElement('div');
        arrows.className = 'pagination-arrows d-flex justify-content-between align-items-center';

        leftCol = document.createElement('div');
        leftCol.className = 'd-flex align-items-center';

        linksCol = document.createElement('div');
        linksCol.className = 'd-flex pagination-links align-items-end justify-content-center';

        if (currentPage > 1) {
            firstArrow = document.createElement('a');
            firstArrow.href = buildPageUrl(0, size);
            firstArrow.className = 'pagination-arrow pagination-arrow--first px-2';
            firstArrow.setAttribute('aria-label', 'first page');
            firstArrow.innerHTML = '<i class="fa fa-angle-double-left"></i>';
            firstArrow.addEventListener('click', function (event) {
                event.preventDefault();
                setPaginationParams(0, size);
                runSearch();
                triggerBackToTop();
            });
            leftCol.appendChild(firstArrow);

            prevStep = document.createElement('a');
            prevStep.href = buildPageUrl(Math.max(0, from - size), size);
            prevStep.className = 'pagination-arrow-step text-uppercase mx-2';
            prevStep.textContent = 'Prev';
            prevStep.addEventListener('click', function (event) {
                event.preventDefault();
                setPaginationParams(Math.max(0, from - size), size);
                runSearch();
                triggerBackToTop();
            });
            leftCol.appendChild(prevStep);
        }

        if (pageNumbers[0] > 1) {
            pageLink = document.createElement('a');
            pageLink.href = buildPageUrl(0, size);
            pageLink.className = 'btn btn-link pagination-link p-2 mx-1';
            pageLink.textContent = '1';
            pageLink.setAttribute('data-current-url', buildPageUrl(0, size));
            pageLink.addEventListener('click', function (event) {
                event.preventDefault();
                setPaginationParams(0, size);
                runSearch();
                triggerBackToTop();
            });
            linksCol.appendChild(pageLink);

            skip = document.createElement('a');
            skip.className = 'pagination-skip p-2 mx-1';
            skip.textContent = '...';
            linksCol.appendChild(skip);
        }

        for (page = 0; page < pageNumbers.length; page++) {
            lastPage = pageNumbers[page];
            start = (lastPage - 1) * size;
            pageLink = document.createElement('a');
            pageLink.href = buildPageUrl(start, size);
            pageLink.className = 'btn btn-link pagination-link p-2 mx-1' +
                (lastPage === currentPage ? ' active mx-0 px-3' : '');
            pageLink.textContent = String(lastPage);
            pageLink.setAttribute('data-current-url', buildPageUrl(start, size));
            (function bindPageLink(pageNumber, pageStart) {
                pageLink.addEventListener('click', function (event) {
                    event.preventDefault();
                    setPaginationParams(pageStart, size);
                    runSearch();
                    triggerBackToTop();
                });
            })(lastPage, start);
            linksCol.appendChild(pageLink);
        }

        if (pageNumbers[pageNumbers.length - 1] < totalPages) {
            skip = document.createElement('a');
            skip.className = 'pagination-skip p-2 mx-1';
            skip.textContent = '...';
            linksCol.appendChild(skip);

            start = (totalPages - 1) * size;
            pageLink = document.createElement('a');
            pageLink.href = buildPageUrl(start, size);
            pageLink.className = 'btn btn-link pagination-link p-2 mx-1' +
                (totalPages === currentPage ? ' active mx-0 px-3' : '');
            pageLink.textContent = String(totalPages);
            pageLink.setAttribute('data-current-url', buildPageUrl(start, size));
            pageLink.addEventListener('click', function (event) {
                event.preventDefault();
                setPaginationParams(start, size);
                runSearch();
                triggerBackToTop();
            });
            linksCol.appendChild(pageLink);
        }

        rightCol = document.createElement('div');
        rightCol.className = 'd-flex align-items-center';

        if (currentPage < totalPages) {
            nextStep = document.createElement('a');
            nextStep.href = buildPageUrl(from + size, size);
            nextStep.className = 'pagination-arrow-step text-uppercase mx-2';
            nextStep.textContent = 'Next';
            nextStep.setAttribute('data-current-url', buildPageUrl(from + size, size));
            nextStep.addEventListener('click', function (event) {
                event.preventDefault();
                setPaginationParams(from + size, size);
                runSearch();
                triggerBackToTop();
            });
            rightCol.appendChild(nextStep);

            lastArrow = document.createElement('a');
            lastArrow.href = buildPageUrl((totalPages - 1) * size, size);
            lastArrow.className = 'pagination-arrow pagination-arrow--last px-2';
            lastArrow.setAttribute('aria-label', 'last page');
            lastArrow.setAttribute('data-current-url', buildPageUrl((totalPages - 1) * size, size));
            lastArrow.innerHTML = '<i class="fa fa-angle-double-right"></i>';
            lastArrow.addEventListener('click', function (event) {
                event.preventDefault();
                setPaginationParams((totalPages - 1) * size, size);
                runSearch();
                triggerBackToTop();
            });
            rightCol.appendChild(lastArrow);
        }

        arrows.appendChild(leftCol);
        arrows.appendChild(linksCol);
        arrows.appendChild(rightCol);
        footer.appendChild(arrows);
        resultsEl.appendChild(footer);
    }

    function bindRefinementActions() {
        var refinementsEl = document.getElementById('nosto-refinements');
        if (!refinementsEl || refinementsEl.getAttribute('data-nosto-bound') === 'true') {
            return;
        }

        refinementsEl.addEventListener('click', function (event) {
            var node = event.target;

            while (node && node !== refinementsEl) {
                if (node.tagName === 'BUTTON' && node.getAttribute('data-href')) {
                    event.preventDefault();
                    event.stopPropagation();
                    applyHref(node.getAttribute('data-href'));
                    setPaginationParams(0, numberParam('sz', 24));
                    runSearch();
                    return;
                }
                node = node.parentNode;
            }
        });

        refinementsEl.setAttribute('data-nosto-bound', 'true');
    }

    async function runSearch() {
        var requestId = ++activeRequestId;
        var config = getConfig();
        var q = getParam('q');
        var size = numberParam('sz', 24);
        var from = numberParam('start', 0);
        var selectedFilterMap = getSelectedFilterMap();
        var sortRule = getSortRuleFromUrl();
        var nostoFilters = buildNostoFilters(selectedFilterMap, config.categoryPath);
        var facetStateKey = buildFacetStateKey(q, config.categoryPath, selectedFilterMap);
        var includeFacets = facetStateKey !== refinementState.key || !refinementState.html;
        var resultsEl = document.getElementById('nosto-results');
        var metaEl = document.getElementById('nosto-meta');
        var refinementsEl = document.getElementById('nosto-refinements');
        var noResultsEl = document.querySelector('.nosto-no-search-results');
        var productsQuery = {
            size: size,
            from: from,
            fields: ['productId']
        };
        var requestPayload;
        var response;
        var redirectUrl;
        var node;
        var total;
        var facets;
        var hits;
        var ids;
        var tilesPromise;
        var refinementsPromise;
        var tilesHtml;
        var refinementsHtml;

        if (resultsEl) {
            resultsEl.innerHTML = getResultsShimmerMarkup(size);
        }

        if (noResultsEl) {
            noResultsEl.classList.add('d-none');
        }

        if (refinementsEl && includeFacets) {
            refinementsEl.innerHTML = getRefinementShimmerMarkup();
        }

        if (nostoFilters.length) {
            productsQuery.filter = nostoFilters;
        }

        if (config.currency) {
            productsQuery.variationId = config.currency;
        }

        applySortToProductsQuery(productsQuery, sortRule);

        if (includeFacets) {
            productsQuery.facets = ['*'];
        }

        requestPayload = {
            accountId: config.accountId,
            products: productsQuery
        };

        if (q) {
            requestPayload.query = q;
        }

        try {
            response = await searchNosto(requestPayload, {
                track: false,
                redirect: false
            });

            if (requestId !== activeRequestId) {
                return;
            }

            redirectUrl = (response && response.redirect && response.redirect.url) ||
                (response && typeof response.redirect === 'string' ? response.redirect : null);

            if (redirectUrl) {
                window.location.assign(redirectUrl);
                return;
            }

            node = extractSearchNode(response);
            total = node && node.products ? (node.products.total || 0) : 0;
            facets = node && node.products ? node.products.facets : [];
            hits = node && node.products ? node.products.hits : [];
            ids = (hits || []).map(function (hit) {
                return (hit && (hit.productId || hit.productID || hit.product_id)) || '';
            }).filter(Boolean);

            if (metaEl) {
                metaEl.textContent = formatTotal(total);
            }

            syncSortSelection(sortRule);

            tilesPromise = fetchTilesHtml(config.tilesUrl, ids);
            refinementsPromise = includeFacets
                ? fetchRefinementsHtml(config.refinementsUrl, facets, !!total, total, config.currency)
                : Promise.resolve('');

            tilesHtml = await tilesPromise;

            if (requestId !== activeRequestId) {
                return;
            }

            if (resultsEl) {
                resultsEl.innerHTML = tilesHtml || '';
                renderInlineCategoryRecommendation(
                    resultsEl,
                    config.recommendationTileUrl,
                    getRecommendationPosition(config)
                );
            }

            if (!ids.length) {
                if (noResultsEl) {
                    noResultsEl.classList.remove('d-none');
                }
                renderPagination(0, size, from);
            } else {
                renderPagination(total, size, from);
            }

            refinementsHtml = await refinementsPromise;

            if (requestId !== activeRequestId) {
                return;
            }

            if (includeFacets && refinementsEl) {
                refinementState.key = facetStateKey;
                refinementState.html = refinementsHtml || '';
                refinementsEl.innerHTML = refinementState.html;
            } else if (refinementsEl && refinementState.html && !refinementsEl.innerHTML) {
                refinementsEl.innerHTML = refinementState.html;
            }
        } catch (error) {
            if (requestId !== activeRequestId) {
                return;
            }

            if (resultsEl) {
                resultsEl.innerHTML = '<div>Search error</div>';
            }

            if (metaEl) {
                metaEl.textContent = formatTotal(0);
            }

            if (refinementsEl && includeFacets) {
                refinementsEl.innerHTML = '';
            }

            // eslint-disable-next-line no-console
            console.error('Nosto search failed', error);
        }
    }

    bindRefinementActions();
    runSearch();

    window.addEventListener('popstate', function () {
        runSearch();
    });

    window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            var config = getConfig();
            var resultsEl = document.getElementById('nosto-results');

            renderInlineCategoryRecommendation(
                resultsEl,
                config.recommendationTileUrl,
                getRecommendationPosition(config)
            );
        }, 150);
    });

    window.runSearch = runSearch;
}

module.exports = initNostoSearch;
